import $ from 'jquery';

const object = orecaObject;

const qualiopi_mobile = $('.js-training-qualiopi-mobile')
const qualiopi_desktop = $('.js-training-qualiopi-desktop')
const contact_mobile = $('.js-training-contact-mobile')
const contact_desktop = $('.js-training-contact-desktop')

const contact_content = contact_mobile.html()
const qualiopi_content = qualiopi_mobile.html()

const jsSidebarContent = () => {
    const bodyWidth = $('body').outerWidth()
    if (bodyWidth < 991) {
        qualiopi_mobile.html(qualiopi_content)
        contact_mobile.html(contact_content)

        qualiopi_desktop.html('')
        contact_desktop.html('')
    }
    else {
        qualiopi_mobile.html('')
        contact_mobile.html('')

        qualiopi_desktop.html(qualiopi_content)
        contact_desktop.html(contact_content)
    }
};

$(window)
    .on('resize', function () {
        jsSidebarContent();
    })
    .trigger('resize');